/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsGetCurrency } from "../../funcs/budgetsGetCurrency.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$budgetsGetCurrency: ToolDefinition = {
  name: "budgets-get-currency",
  description: `Get display currency`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await budgetsGetCurrency(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
